// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedIn_container__EaH38","featured_in":"FeaturedIn_featured_in__W5iXz","heading":"FeaturedIn_heading__X583m","image_wrapper":"FeaturedIn_image_wrapper__TIFk9"};